import { render, staticRenderFns } from "./DetailImageIdentity.vue?vue&type=template&id=c2fe6df8"
import script from "./DetailImageIdentity.vue?vue&type=script&lang=js"
export * from "./DetailImageIdentity.vue?vue&type=script&lang=js"
import style0 from "./DetailImageIdentity.vue?vue&type=style&index=0&id=c2fe6df8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports